import { Skeleton, TableBody, TableCell, TableRow } from "@mui/material";

interface Props {
  columnCount: number;
  rowCount?: number;
}

export default function OverviewSkel({ columnCount, rowCount = 10 }: Props) {
  return (
    <TableBody>
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <TableRow key={rowIndex}>
          {Array.from({ length: columnCount }).map((_, colIndex) => (
            <TableCell key={`${rowIndex}-${colIndex}`} align="left">
              <Skeleton
                variant="text"
                width={colIndex === 0 ? 130 : 90}
                height={24}
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
}
